export default __webpack_public_path__ + "static/media/frg--sales-display.373965de.png";